module.exports = __webpack_public_path__ + "static/media/query.15923cc6.svg";